import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const PauseIcon = ({ className = '', width = 13,  height = 13 , color = 'currentColor' }) => {
    return (
        <svg
            className={`icon-13-13 ${className ? className : ''}`}
            fill='none'
            height={height}
            viewBox='0 0 13 13'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <line
                stroke={color}
                x1='3.5'
                x2='3.5'
                y1='1.5'
                y2='11.5'/>
            <line
                stroke={color}
                x1='9.5'
                x2='9.5'
                y1='1.5'
                y2='11.5'/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default PauseIcon;
